/**
 * App-wide configuration for the print generator.
 *
 * These values control where the printed QR codes point and how the
 * cards are labelled / colored. Tweak here rather than hunting through
 * the print page.
 */
export interface PrintConfig {
  /** Production origin baked into every claim URL's QR code. */
  claimOrigin: string;
  /** Relays embedded in the naddr (empty = none). */
  relays: string[];
  /** Foreground color of the QR dots/finders on the card back. */
  qrColor: string;
  /** Heading shown on the card back (e.g. "You found a treasure!"). */
  backHeading: string;
  /** Color used for the back-card text. */
  textColor: string;
  /**
   * Whether to recolor the centered chest logo to the pop-art palette
   * (pairs with the violet QR). When false, the original green chest is
   * used.
   */
  recolorLogo: boolean;
}

export const DEFAULT_CONFIG: PrintConfig = {
  claimOrigin: "https://treasures.to",
  relays: [],
  qrColor: "#c01a92",
  backHeading: "You found a treasure!",
  textColor: "#3d1a5e",
  recolorLogo: true,
};
